import React from 'react'
import { colors } from 'component-library/__styling/settings'

export interface Props {
    className?: string
}

export const IconArrow: React.FC<Props> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 11">
        <path fill={colors.black} d="M.31.05l7.42 5.3-7.41 5.33L.3 5.37z" />
    </svg>
)
